import { EventAnnotationInputModel } from 'inputModels';
import { IDemandViewModel, IDemandProposalViewModal, ISolicitationViewModel } from 'viewModels';
import { useEffect, useState } from 'react';
import IconView from '../../../assets/icons/icon-view.svg';
import IconAdd from '../../../assets/icons/IconAdd.svg';
import { ReactComponent as IconCloseCircle } from '../../../assets/icons/IconCloseCircle.svg';
import GoogleSchedule from '../../../assets/images/google_calendar.png';
import Outlook from '../../../assets/images/outlook.png';
import { useAuth } from '../../../context/auth';
import { IEvent } from '../../../context/events';
import EventController from '../../../controller/EventController';
import { Container, ContainerMakingNoteEvent, Description, Title } from './styles';
import { ModalDetailsService } from '../../../components/Modals/ModalDetailsSolicitation';

export type TypeEvent =
  | 'annotation'
  | 'google'
  | 'outlook'
  | 'solicitation'
  | 'late'
  | 'pending'
  | 'accept'
  | 'empty'
  | 'demandProposal'
  | 'demand';
export type ColorEvent = 'todayOrLater' | 'insideTimeLimit' | 'demandProposal' | 'empty';

type Props = {
  zIndex: number;
  left: number;
  type: TypeEvent;
  color: ColorEvent;
  data: IEvent;
  hasBlur: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  date?: Date;
  getAnnotations: () => void;
  removeEvent?: () => void;
};

export function Event({
  type,
  zIndex,
  left,
  data,
  color,
  onMouseEnter,
  onMouseLeave,
  hasBlur,
  date,
  getAnnotations,
  removeEvent,
}: Props) {
  const { user } = useAuth();
  const [isMakingNote, setIsMakingNote] = useState(false);
  //const [displayModalDetailsEvents, setDisplayModalDetailsEvents] = useState(false);
  const [isOpenServiceModal, setOpenServiceModal] = useState(false);
  const [selectedSolicitation, setSelectedSolicitation] = useState<ISolicitationViewModel>();
  const [selectedDemandProposal, setSelectedDemandProposal] = useState<IDemandProposalViewModal>();
  const [selectedDemand, setSelectedDemand] = useState<IDemandViewModel>();
  const [saveLetterText, setSaveLetterText] = useState('');

  const handleSaveText = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setSaveLetterText(e.target.value);
  };

  useEffect(() => {
    setSelectedSolicitation(data.solicitation);
  }, [data.solicitation]);

  useEffect(() => {
    setSelectedDemandProposal(data.demandProposal);
  }, [data.demandProposal]);

  useEffect(() => {
    setSelectedDemand(data.demand);
  }, [data.demand]);

  const handleRequestClose = () => {
    setOpenServiceModal(false);
  };

  const insertAnnotation = () => {
    const eventAnnotation: EventAnnotationInputModel = {
      annotation: saveLetterText,
      date: new Date(
        date?.getFullYear() as number,
        date?.getMonth() as number,
        (date?.getDate() as number) + 1,
        (date?.getHours() as number) + 1,
        0,
        0,
        0,
      ),
      userId: user.id,
    };
    EventController.insertAnnotation(eventAnnotation).then(() => {
      setIsMakingNote(false);
      setSaveLetterText('');
      getAnnotations();
    });
  };

  const handleRemoveDemand = () => {
    setSelectedDemandProposal(undefined);
    removeEvent?.();
  };

  return (
    <Container
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
      zIndex={zIndex}
      left={left}
      color={color}
      hasBlur={hasBlur}>
      {type === 'google' || type === 'outlook' ? (
        <div className="event-schedule">
          <header>
            <img
              src={type === 'google' ? GoogleSchedule : Outlook}
              alt={`icon ${type === 'google' ? 'google' : 'outlook'}`}
            />
          </header>
          <p>{data?.title || 'Não informado'}</p>
          {data?.conference && (
            <a href={data.conference} target="_blank" rel="noreferrer">
              ingressar
            </a>
          )}
        </div>
      ) : type === 'empty' ? (
        isMakingNote ? (
          <ContainerMakingNoteEvent>
            <div className="close-button">
              <button
                type="button"
                onClick={() => {
                  setIsMakingNote(false);
                }}>
                <IconCloseCircle />
              </button>
            </div>
            <textarea
              id="textMakingNote"
              placeholder="Escreva sua nota..."
              onChange={handleSaveText}
            />
            <div className="makingNotesButtons">
              <button type="button" onClick={insertAnnotation}>
                Adicionar nota
              </button>
            </div>
          </ContainerMakingNoteEvent>
        ) : (
          <ContainerMakingNoteEvent>
            <button type="button" id="ButtonAddAnotation" onClick={() => setIsMakingNote(true)}>
              <img id="IconAdd" src={IconAdd} alt="Ícone de adicionar anotação" />
            </button>
          </ContainerMakingNoteEvent>
        )
      ) : type === 'annotation' ? (
        <div id="divContainerEvents">
          <Title>{data?.annotation}</Title>
        </div>
      ) : (
        <>
          <div id="divContainerEvents">
            <Title>{data?.title}</Title>
            <button
              type="button"
              onClick={() => {
                setOpenServiceModal(true);
              }}>
              <img src={IconView} alt="Visualizar evento" />
            </button>
          </div>
          {type !== 'pending' ? (
            <Description>{data?.description}</Description>
          ) : (
            <button
              type="button"
              onClick={() => setOpenServiceModal(true)}
              className="btn-view-solicitation">
              Ver solicitação
            </button>
          )}
        </>
      )}
      {isOpenServiceModal && (
        <ModalDetailsService
          zIndex={25}
          onRequestClose={handleRequestClose}
          solicitation={selectedSolicitation}
          demandProposal={selectedDemandProposal}
          demand={selectedDemand}
          isOpen={isOpenServiceModal}
          removeEvent={handleRemoveDemand}
        />
        /*<ModalDetailsEvent
        type={type}
        data={{
          id: data.id,
          title: data?.title,
          expirationDate: new Date(data.date),
          service: data.conference,
          place: data.place,
          attachments: data?.attachments,
          comments: data.description,
          price: data.value,
          note: data.note,
          processNumber: data.processNumber ?? '-',
          isLawyer: data.isLawyer,
          isRepresentative: data.isRepresentative,
          audienceType: data.audienceType,
          isVirtualAudience: data.isVirtualAudience,
          audienceLink: data.audienceLink,
          isIntegratedProtocol: data.isIntegratedProtocol,
          integratedProtocolValue: data.integratedProtocolValue,
          districtName: data.districtName ?? 'Comarca',
          districtState: data.districtState ?? 'UF',
          userId: data.userId,
          correspondent: data.correspondent,
        }}
        isOpen={displayModalDetailsEvents}
        close={() => {
          setDisplayModalDetailsEvents(false);
          onMouseLeave();
        }}
      />*/
      )}
    </Container>
  );
}
